import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function LeTeletravailCaADesLimites({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>
        Depuis la crise sanitaire liée à la COVID-19, les Pouvoirs Publics
        incitent au télétravail et la Direction commence à s'y engager.
      </p>
      <p>Mais ne nous y trompons pas !</p>
      <p>
        C'est là une nouvelle mesure permettant à la Direction d'en demander
        PLUS, encore et toujours, avec des moyens de plus en plus réduits !
      </p>
      <p>
        Le télétravail, oui ! Il permettra d'être à la maison et d'assurer sa
        protection individuelle et familiale, dans un contexte sanitaire
        dangereux, tout en maintenant son activité professionnelle. Mais il doit
        y avoir des limites !
      </p>
      <p className="font-bold underline">
        Nous, syndicalistes de {variablesData.delegue_syndical_societe} restons
        mobilisés pour vous défendre et éviter que le télétravail devienne une
        nouvelle dérive du droit à la déconnexion !!
      </p>
      <p>
        Nous vous rappelons que nous nous sommes battus lors des dernières
        élections professionnelles pour que notre accord de droit à la
        déconnexion vous permette de trouver un équilibre entre vie familiale et
        vie professionnelle ! Nous sommes soucieux de votre santé et de votre
        charge de travail !
      </p>
      <p>
        Restez mobilisés à nos côtés ET NE NOUS LAISSONS PAS FAIRE ! Nous ne
        sommes pas des esclaves corvéables à merci, 7 jours sur 7 et 24 heures
        sur 24 !
      </p>
      <p className="font-bold underline">
        BATTEZ-VOUS en ces temps de « guerre » pour maintenir vos droits les
        plus élémentaires !
      </p>
      <p>
        Tant que la Direction n'installera pas de réel outil de suivi du temps
        de travail à distance, n'aménagera pas les charges de travail et n'aura
        pas négocié un accord d'entreprise avec NOUS, nous serons opposés au
        télétravail mis en place sans garde-fou !
      </p>
      <p>
        Nous ne voulons pas qu'une simple charte, d'auto-engagement de
        l'employeur, nous immobilise, NOUS, travailleurs de l'entreprise !
      </p>
      <p className="font-bold underline">
        A VOUS, DIRECTION, DE FAIRE FACE A VOS RESPONSABILITES ! NEGOCIONS !
      </p>
      <p>
        Dans l'attente de la négociation de l'accord relatif à la mise en place
        du télétravail, nous vous invitons à rester{" "}
        <span>EXTREMEMENT VIGILANTS</span> à vos conditions de travail (et
        télétravail).
      </p>
      <p className="font-bold underline">
        NE VOUS LAISSEZ PAS PIEGER et tenez-nous informés pour nous dire où vous
        en êtes !
      </p>
      <p>
        Vous pouvez contacter votre délégué {variablesData.syndicat_nom},{" "}
        {variablesData.genre_masc_complet} {variablesData.delegue_syndical_nom},
        Département Administration ou dans la boite aux lettres{" "}
        {variablesData.syndicat_nom}.
      </p>
      <MailSignature
        emetteurLogo={LeTeletravailCaADesLimites.metadata.emetteurLogo}
        emetteur={LeTeletravailCaADesLimites.metadata.emetteur}
        emetteurPoste={LeTeletravailCaADesLimites.metadata.emetteurPoste}
        emetteurEntreprise={
          LeTeletravailCaADesLimites.metadata.emetteurEntreprise
        }
      />
    </div>
  );
}

LeTeletravailCaADesLimites.metadata = {
  titre: "Le télétravail, ça a DES LIMITES !",
  cleMail: "le_teletravail_ca_a_des_limites",
  messageTransfert: false,
  emetteur: "Syndicat ITEP",
  emetteurPoste: "",
  emetteurEntreprise: "",
  emetteurLogo: null,
  dateRelative: -9,
  piecesJointes: [],
} as MailMetadata;

export default LeTeletravailCaADesLimites;
